module.exports = __webpack_public_path__ + "img/ext14.6e217ecc.jpg";